import React from 'react';
import {Button, Col, ConfigProvider, Form, Input, Modal, Row} from 'antd';
import Colors from "../styles/Colors";
import {BiCheck, BiX} from "react-icons/bi";
import locale from "antd/es/locale/es_ES";

interface IngredientModalProps {
    element: object;
    visible: boolean;
    onClose: (value: boolean) => void;
    editar?: boolean;
}

const PlantillaModal: React.FC<IngredientModalProps> = ({element, visible, onClose, editar}) => {
    const [form] = Form.useForm();

    async function handleSubmit () {
        const formData = form.getFieldsValue();
        console.log("Form Data:", formData);
        console.log(JSON.stringify(formData));

        //onClose(true);
    };

    const handleCancel = () => {
        onClose(false);
    };

    return (
        <ConfigProvider locale={locale}>
        <Modal
            title="Editar Ingrediente"
            open={visible}
            onCancel={handleCancel}
            footer={[
            ]}
            width={1000}
        >
            <Form form={form} initialValues={element} onFinish={handleSubmit} disabled={!editar}>
                <hr/>
                <Row gutter={[16, 16]}>
                    <Col span={12}>
                        <Form.Item label="ID" name="id">
                            <Input disabled/>
                        </Form.Item>
                        <Form.Item label="Nombre" name="nom"
                                   rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <Input/>
                        </Form.Item>
                        <Form.Item label="Precio" name="preu"
                                   rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <Input type="number"/>
                        </Form.Item>
                        <Form.Item label="Cocina" name="cuina"
                                   rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <Input/>
                        </Form.Item>
                        <Form.Item label="Estado" name="estat"
                                   rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <Input type="number"/>
                        </Form.Item>
                        <Form.Item label="Tipo" name="tipus"
                                   rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <Input/>
                        </Form.Item>
                        <Form.Item label="Medida" name="mesura"
                                   rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <Input/>
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label="Alergia" name="alergia"
                                   rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <Input type="number"/>
                        </Form.Item>
                        <Form.Item label="Propuesta" name="proposta"
                                   rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <Input/>
                        </Form.Item>
                        <Form.Item label="ID Proveedor 1" name="idProveidor1"
                                   rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <Input type="number"/>
                        </Form.Item>
                        <Form.Item label="ID Proveedor 2" name="idProveidor2"
                                   rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <Input type="number"/>
                        </Form.Item>
                        <Form.Item label="Proveedor 1" name="proveidor1"
                                   rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <Input/>
                        </Form.Item>
                        <Form.Item label="Proveedor 2" name="proveidor2"
                                   rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <Input/>
                        </Form.Item>
                        <Form.Item label="Stock Mínimo" name="minim_stock"
                                   rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <Input type="number"/>
                        </Form.Item>
                    </Col>
                </Row>
                <hr/>
                <Row gutter={[16, 16]}>
                    <Col span={1}>
                        <Form.Item wrapperCol={{offset: 0, span: 16}}>
                            <Button title={"Aceptar"} htmlType={"submit"}
                                    style={{backgroundColor: Colors.colors.color6}}><BiCheck/></Button>
                        </Form.Item>
                    </Col>
                    <Col span={1}>
                    </Col>
                    <Col span={1}>
                        <Button title={"Cancelar"} style={{backgroundColor: Colors.colors.color1}}
                                onClick={handleCancel}><BiX/></Button>
                    </Col>
                </Row>
            </Form>
        </Modal>
        </ConfigProvider>
    );
};

export default PlantillaModal;
